import {useMutation, useQueryClient} from 'react-query'
import axios, {AxiosResponse} from 'axios'
import toast from 'react-hot-toast'
import {useRouteConfig} from '../ConfigRoutesProvider'
import {BASE_URL} from '../../config'
import {KTIcon} from '../../../../_metronic/helpers'

const DELETE_SERVER_BY_ID = `${BASE_URL}/api/protect/deleteRouteConfig`

const DeleteRouteConfig = () => {
  const queryClient = useQueryClient()
  const {deleteRoute, setDeleteRoute} = useRouteConfig()

  const onClose = () => setDeleteRoute(null)

  const {mutateAsync: deleteServer} = useMutation<AxiosResponse>({
    mutationFn: async () => {
      const response = await axios.delete(`${DELETE_SERVER_BY_ID}/${deleteRoute?.id}`)

      return response
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['routeConfigList'])
    },
  })

  const onDeleteServer = async () => {
    toast.loading('Deleteing..')
    const response = await deleteServer()
    const result = await response.data

    if (response.status === 201) {
      toast.dismiss()
      toast.success(result.message)
    } else {
      toast.dismiss()
      toast.error(result.message)
    }
  }

  return (
    <div className='modal fade' tabIndex={-2} id='kt_modal_2'>
      {/* begin::Modal dialog */}
      <div className='modal-dialog modal-dialog-centered modal-md p-12'>
        {/* begin::Modal content */}
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>Delete Route</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
              onClick={onClose}
            >
              <KTIcon iconName='cross' className='fs-1' />
            </div>
          </div>
          {/* begin::Modal body */}
          <div className='modal-body scroll-y my-5 mx-10'>
            {deleteRoute ? (
              <>
                <p className='fs-4 fw-semibold text-danger text-center m-0'>
                  Are you sure? <br />
                </p>
                <p className='fs-4 fw-semibold text-danger text-center'>
                  You want to delete {deleteRoute.name}? <br />
                </p>

                <div className='text-center pt-15'>
                  <button
                    type='reset'
                    className='btn btn-light me-3'
                    data-kt-users-modal-action='cancel'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={onClose}
                  >
                    Discard
                  </button>

                  <button
                    type='submit'
                    className='btn btn-danger'
                    data-kt-users-modal-action='submit'
                    data-bs-dismiss='modal'
                    aria-label='Close'
                    onClick={onDeleteServer}
                  >
                    <span className='indicator-label'>Delete</span>
                  </button>
                </div>
              </>
            ) : (
              <p className='fs-4 fw-semibold text-center'>Loading..</p>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default DeleteRouteConfig
